import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  Icon,
  Menu,
  MenuItem,
} from '@unite-us/ui';
import ToolTip from 'src/common/ToolTip/ToolTip';

const BulkExportInvoices = ({
  action,
  onClick,
  icon,
  disabled,
}) => {
  const [showTooltip, setShowTooltip] = useState(true);
  const exportOptions = [
    { label: 'Download With Attachments', value: true },
    { label: 'Download Without Attachments', value: false },
  ];

  return (
    <ToolTip
      buttonClassName="focus:outline-none"
      buttonComponentContent={() => (
        <div className={`Bulk ${action} mx-0`}>
          <span className="text-lg flex flex-row">
            <Menu
              anchorElement={(
                <button
                  type="button"
                  disabled={disabled}
                  className={`${disabled ? 'fill-current opacity-25' : 'fill-current'}`}
                  aria-label={`Bulk-Action-${action}-Button`}
                  onMouseEnter={() => setShowTooltip(true)}
                >
                  <Icon
                    icon={icon}
                    size={25}
                    className={`${disabled ? 'fill-current opacity-25' : 'fill-current'}`}
                  />
                </button>
              )}
            >
              {
                exportOptions.map((option) => (
                  <MenuItem
                    primaryNode={option.label}
                    onClick={() => {
                      onClick(option.value);
                      setShowTooltip(false);
                    }}
                  />
                ))
              }
            </Menu>
          </span>
        </div>
      )}
      panelComponentContent={() => (
        <p className="text-white flex items-center justify-center font-bold">
          {action}
        </p>
      )}
      panelClassName="mt-1 bg-grey border mb-2 w-20 p-2 text-white
        border-solid rounded-md shadow-lg leading-normal rounded"
      enableHover
      hoverDelay={0}
      placement="bottom"
      offsetOptions={{ offset: [0, 5] }}
      flipOptions={{ fallbackPlacements: [] }}
      showTooltip={showTooltip || disabled}
      data-testid="export-invoices-button"
    />
  );
};

BulkExportInvoices.propTypes = {
  onClick: PropTypes.func.isRequired,
  icon: PropTypes.string.isRequired,
  action: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
};

BulkExportInvoices.defaultProps = {
  disabled: false,
};

export default BulkExportInvoices;
